module.exports = __webpack_public_path__ + "img/news12-0.53de43c7.png";